import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { ProblemSection } from './components/ProblemSection';
import { ServicesOverview } from './components/ServicesOverview';
import { DifferentiationSection } from './components/DifferentiationSection';
import { ProcessSection } from './components/ProcessSection';
import { MidPageCTA } from './components/MidPageCTA';
import { FounderSection } from './components/FounderSection';
import { OutcomesSection } from './components/OutcomesSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  return <div className="min-h-screen bg-brand-off-white text-brand-charcoal selection:bg-brand-magenta/20 selection:text-brand-charcoal" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBar data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <ServicesOverview data-id="element-6" />
        <DifferentiationSection data-id="element-7" />
        <ProcessSection data-id="element-8" />
        <MidPageCTA data-id="element-9" />
        <FounderSection data-id="element-10" />
        <OutcomesSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <StickyMobileCTA data-id="element-15" />
    </div>;
}